import Vue from 'vue'
import Router from 'vue-router'

import routeMonitoring from './routeMonitoring'
import routeAccountTypes from './routeAccountTypes'
import routePartners from './routePartners'
import routeAgencies from './routeAgencies'
import routeClients from './routeClients'
import routeUsers from './routeUsers'
import routeUserRegistration from './routeUserRegistration'
import routeDrivers from './routeDrivers'
import routeVehicles from './routeVehicles'
import routeVehicleExpenses from './routeVehicleExpenses'
import routeVehicleGroups from './routeVehicleGroups'
import routeUnitsArchives from './routeUnitsArchives'
import routeUnitsSwapping from './routeUnitsSwapping'
import routeUnitGroups from './routeUnitGroups'
import routeUnits from './routeUnits'
import routeCfgTemplates from './routeCfgTemplates'
import routeReports from './routeReports'
import routeEventProfiles from './routeEventProfiles'
import routeEventPools from './routeEventPools'
import routeSimCards from './routeSimCards'
import routeGDSPOSimCards from '@/router/routeGDSPOSimCards'
import routeUnitCommands from '@/router/routeUnitCommands'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'home',
      path: '/',
      component: () => import('@/views/dashboards/Dashboard')
    },
    ...routeMonitoring,
    ...routeAccountTypes,
    ...routePartners,
    ...routeAgencies,
    ...routeClients,
    ...routeUsers,
    ...routeUserRegistration,
    ...routeDrivers,
    ...routeVehicles,
    ...routeVehicleExpenses,
    ...routeVehicleGroups,
    ...routeUnitsArchives,
    ...routeUnitsSwapping,
    ...routeUnitGroups,
    ...routeUnits,
    ...routeCfgTemplates,
    ...routeReports,
    ...routeEventProfiles,
    ...routeEventPools,
    ...routeSimCards,
    ...routeGDSPOSimCards,
    ...routeUnitCommands,
    {
      name: 'login',
      path: '/login',
      component: () => import('@/views/login/Login')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js